<template>
  <div class="chooose_group">
    <div class="layerWrap">
      <div class="layer"></div>
        <div class="container_date">
          <span class="year">年份</span>
          <div class="grid">
            <label class="label-checkbox item-content" v-for="year in yearList">
              <input type="radio" class="radio-input-month" name="attr_month" :value="year">
              <div :class="{'col1': true, 'research-background-color': isSelectedYear[year]}" @click="updateYear(year)" ><span class="tag">{{year}}年</span></div>
            </label>
          </div>
          <span class="month" v-if="monthOrYear === 'month'">月份</span>
          <div class="grid" v-if="monthOrYear === 'month'">
            <label class="label-checkbox item-content" v-for="month in monthList">
              <input type="radio" class="radio-input-month" name="attr_month" :value="month">
              <div :class="{'col1_month': true, 'research-background-color': isSelectedMonth[month]}" @click="updateMonth(month)" ><span class="tag_month">{{month}}月</span></div>
            </label>
          </div>
          <div class="container_ok">
            <div class="tagWrap_ok research-background-color" @click="confirm"><span class="tag_ok">确认</span></div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'
// import EMKT from '../../../../emkt'
export default {
  data () {
    return {
      monthList: [],
      yearList: [2018, 2019, 2020, 2021],
      isSelectedYear: {},
      isSelectedMonth: {},
      month: '',
      year: ''

    }
  },
  mounted () {
    const list = [...Array(12).keys()]
    this.monthList = list.map(mon => mon + 1)
    this.initIsSelectedYear()
    this.initIsSelectedMonth()
    this.updateMonth(Number(this.defaultMonth))
    this.updateYear(Number(this.defaultYear))
  },
  props: [
    'monthOrYear', 'defaultYear', 'defaultMonth'
  ],
  computed: {
    ...mapGetters([
      'displayChosenResearchGroup'
    ])
  },
  methods: {
    initIsSelectedMonth () {
      const selectedObj = {}
      this.monthList.forEach(mon => {
        selectedObj[mon] = false
      })
      this.isSelectedMonth = selectedObj
    },
    initIsSelectedYear () {
      const selectedObj = {}
      this.yearList.forEach(year => {
        selectedObj[year] = false
      })
      this.isSelectedYear = selectedObj
    },
    updateYear (year) {
      let isTrue = this.isSelectedYear[year]
      this.initIsSelectedYear()
      this.isSelectedYear[year] = !isTrue
      this.year = this.isSelectedYear[year] ? year : ''
    },
    updateMonth (month) {
      let isTrue = this.isSelectedMonth[month]
      this.initIsSelectedMonth()
      this.isSelectedMonth[month] = !isTrue
      this.month = this.isSelectedMonth[month] ? month : ''
    },
    confirm () {
      if (this.monthOrYear === 'month') {
        if (!this.year || !this.month) return $.toast('请选择日期')
        let params = this.year + '-' + (this.month < 10 ? '0' + this.month : this.month)
        this.$emit('getBillInfo', params)
        this.$emit('toggleShow')
      } else if (this.monthOrYear === 'year') {
        if (!this.year) return $.toast('请选择日期')
        let params = this.year
        this.$emit('getBillInfo', params)
        this.$emit('toggleShow')
      }
    }
  }
}
</script>
<style scoped>

.chooose_group {
  position: fixed;
  top: 0;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}

.layerWrap {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.layer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10600;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .4);
  opacity: 1;
  -webkit-transition-duration: 400ms;
  -o-transition-duration: 400ms;
  transition-duration: 400ms;
}


.container_date {
  display: flex;
  position: absolute;
  top: 21.6vw;
  left: 6.67vw;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  /*height: 64.27vw;*/
  padding: 5vw 0;
  z-index: 10601;
}

.year {
  opacity: 1;
  margin-left: 6.67vw;
  max-width: 83.47vw;
  height: 4.53vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.2vw;
  font-weight: 400;
}

.grid {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-left: 6.67vw;
  margin-top: 2.67vw;
  width: 86.4vw;
}

.col1 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #979797;
  width: 17.33vw;
  height: 7.47vw;
  margin-right: 1.33vw;
}

.tag {
  opacity: 1;
  max-width: 14.13vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.2vw;
  font-weight: 400;
}

.month {
  opacity: 1;
  margin-top: 2.67vw;
  margin-left: 6.4vw;
  max-width: 83.73vw;
  height: 4.53vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.2vw;
  font-weight: 400;
}

.col1_month {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #979797;
  /*background-color: #5878fa;*/
  width: 11vw;
  height: 7.47vw;
  margin-right: 1.33vw;
  margin-bottom: 1.33vw;
}
.research-background-color {
  background-color: #5878fa;
}
.tag_month {
  opacity: 1;
  max-width: 8vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.2vw;
  font-weight: 400;
}

.container_ok {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 5.33vw;
  width: 86.4vw;
}

.tagWrap_ok {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  width: 73.87vw;
  height: 7.47vw;
}

.tag_ok {
  opacity: 1;
  max-width: 70.67vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.2vw;
  font-weight: 400;
}


</style>



// WEBPACK FOOTER //
// ChooseBillPeriod.vue?ddbf74a2